import { render, staticRenderFns } from "./editHousekeepingType.vue?vue&type=template&id=64f2735c&scoped=true"
import script from "./editHousekeepingType.vue?vue&type=script&lang=js"
export * from "./editHousekeepingType.vue?vue&type=script&lang=js"
import style0 from "./editHousekeepingType.vue?vue&type=style&index=0&id=64f2735c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2735c",
  null
  
)

export default component.exports